/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MerchantList,
    MerchantListFromJSON,
    MerchantListFromJSONTyped,
    MerchantListToJSON,
    QueryInfo,
    QueryInfoFromJSON,
    QueryInfoFromJSONTyped,
    QueryInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface MerchantListResponse
 */
export interface MerchantListResponse {
    /**
     * 
     * @type {Array<MerchantList>}
     * @memberof MerchantListResponse
     */
    results: Array<MerchantList>;
    /**
     * 
     * @type {QueryInfo}
     * @memberof MerchantListResponse
     */
    listResult: QueryInfo;
    /**
     * Pagination token used in retrieving another page of items
     * @type {string}
     * @memberof MerchantListResponse
     */
    paginationToken?: string;
    /**
     * Whether there are more items in the next page
     * @type {boolean}
     * @memberof MerchantListResponse
     */
    hasNextPage?: boolean;
    /**
     * Whether there are more items in the previous page
     * @type {boolean}
     * @memberof MerchantListResponse
     */
    hasPreviousPage?: boolean;
}

export function MerchantListResponseFromJSON(json: any): MerchantListResponse {
    return MerchantListResponseFromJSONTyped(json, false);
}

export function MerchantListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(MerchantListFromJSON)),
        'listResult': json['listResult'],
        'paginationToken': !exists(json, 'paginationToken') ? undefined : json['paginationToken'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'hasPreviousPage': !exists(json, 'hasPreviousPage') ? undefined : json['hasPreviousPage'],
    };
}

export function MerchantListResponseToJSON(value?: MerchantListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(MerchantListToJSON)),
        'listResult': value.listResult,
        'paginationToken': value.paginationToken,
        'hasNextPage': value.hasNextPage,
        'hasPreviousPage': value.hasPreviousPage,
    };
}


